import { useRouter } from "next/router";
import React, { useContext, useRef, useState, useTransition } from "react";
import { useForm } from "react-hook-form";
import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import _ from "lodash";
import Link from "next/link";
import { Card, Table } from "react-bootstrap";
import attributesModel from "../../models/attributes.model";
import ecomcategoriesModel from "../../models/ecomcategories.model";
import config from "../../lib/config";
import useSWR from "swr";
import AsyncSelect from "react-select/async";
import "react-quill/dist/quill.snow.css";
import dynamic from "next/dynamic";

const ReactQuill = dynamic(() => import("react-quill"), { ssr: false });

const Page = function () {
  const router = useRouter();
  const [attributes, setAttributes] = useState([]);
  const queryParams = router.query;
  const [items, setItems] = useState([]);
  const [inputFields, setInputFields] = useState([{ value: "" }]);
  const [preview, setPreview] = useState(
    "http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
  );
  const [description, setDescription] = useState("");
  const [returnpolicy, setReturnPolicy] = useState("");
  const {
    data: attributeData,
    mutate: reloadAttributeData,
    isLoading,
  } = useSWR(
    queryParams || null,
    () => attributesModel.list(queryParams),
    config.swrConfig
  );
  const { data: ecomcategoriesData, mutate: reloadEcomcategoriesData } = useSWR(
    "ecomcategory",
    () => ecomcategoriesModel.list(queryParams),
    config.swrConfig
  );
  const [item, setItem] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  // State to store selected attribute values for each row
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setError,
  } = useForm();
  const setSlug = function () {
    console.log(watch("title").replace(/ /g, "_"));
    if (watch("slug") == "") {
      setValue("slug", watch("title").toLowerCase().trim().replace(/ /g, "_"));
    }
  };

  const handleAddFields = () => {
    const newIndex = attributes.length;
    const values = [...attributes];
    values.push({ value: "" });
    setAttributes(values);
    // Initialize selected attribute for new row as null
    setSelectedAttributes(prev => ({
      ...prev,
      [newIndex]: null
    }));
    setItem(attributes?.id);
  };

  const handleRemoveFields = (index) => {
    const values = [...attributes];
    values.splice(index, 1);
    setAttributes(values);
    // Remove the selected attribute for this index
    const newSelected = { ...selectedAttributes };
    delete newSelected[index];
    // Re-index remaining items
    const reindexed = {};
    Object.keys(newSelected).forEach(key => {
      const newKey = parseInt(key) > index ? parseInt(key) - 1 : parseInt(key);
      reindexed[newKey] = newSelected[key];
    });
    setSelectedAttributes(reindexed);
  };

  const handleOnSearchcategory = (string, callback) => {
    if (string == "") {
      return null;
    }
    setTimeout(async () => {
      const data = await ecomcategoriesModel
        .list({ title: string })
        .then((res) => {
          const tempData = res?.data;
          tempData?.map((item) => {
            item.value = item.id;
            item.label = item.title;
            return item;
          });
          setItems(tempData);
          return tempData || [];
        });
      callback(data);
    }, 1000);
  };

  const handleOnSearchAttribute = (string, callback) => {
    if (string == "") {
      return null;
    }
    setTimeout(async () => {
      const data = await attributesModel
        .list({ name: string })
        .then((res) => {
          const tempData = res?.data;
          tempData?.map((item) => {
            item.value = item.id;
            item.label = item.name;
            return item;
          });
          return tempData || [];
        });
      callback(data);
    }, 1000);
  };

  const onSubmit = handleSubmit(async (data, event) => {
    console.log("errorrs", errors);
    const formData = new FormData(event.target);
    formData.set("description", description);
    formData.set("return_policy", returnpolicy);
    await ecomcategoriesModel
      .create(formData)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message, "success");
        router.push("/ecomcategories");
      })
      .catch((error) => {
        console.log(error.response.data.errors);
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  const onSelectFile = (e) => {
    console.log(e.target.files[0]);
    // I've kept this example simple by usin;g the first image instead of multiple
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    setPreview(objectUrl);
    //setValue("avatar", e.target.files[0]);
  };

  const handleAttributeChange = async (selectedOption, index) => {
    // Store the selected option in state
    setSelectedAttributes(prev => ({
      ...prev,
      [index]: selectedOption
    }));

    if (selectedOption) {
      // Find the attribute from the data
      const attrs = _.chain(attributeData?.data)
        .find({ id: parseInt(selectedOption.value) })
        .value();
      
      // Set the name (lowercase) and label (original name)
      setValue(`attributes[${index}][name]`, _.lowerCase(attrs?.name || selectedOption.label));
      setValue(`attributes[${index}][label]`, attrs?.name || selectedOption.label);
      setValue(`attributes[${index}][id]`, selectedOption.value);
    } else {
      // Clear values if selection is cleared
      setValue(`attributes[${index}][name]`, "");
      setValue(`attributes[${index}][label]`, "");
      setValue(`attributes[${index}][id]`, "");
    }
  };

  return (
    <>
      <Heading title="Ecom-categories Create" showLoader={showLoader}>
        <Link className="btn btn-primary btn-sm" href={`/ecomcategories`}>
          <i className="bi bi-list" /> List
        </Link>
      </Heading>
      <form onSubmit={onSubmit} className="container-fluid">
        <div className="card">
          <div className="card-header">Create</div>
          <div className="card-body row g-3">
            <div className="col-6 col-md-3">
              <img src={preview} className="w-100 border rounded" alt="" />
              <div className="m-1">
                <label className="custom-file-upload">
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    {...register("image", { onChange: onSelectFile })}
                  />
                  <b className="btn btn-dark">Upload</b>
                </label>
              </div>
              <div className="invalid-feedback">
                {errors.image && errors.image.message}
              </div>
            </div>
            <div className="col-md-9">
              <label className="form-label">Title</label>
              <input
                type="text"
                className={`form-control ${errors?.title && "is-invalid"}`}
                {...register("title", {
                  onBlur: () => setSlug(),
                  required: "Title is required",
                })}
              />
              <div className="invalid-feedback">
                {errors.title && errors.message}
              </div>
              {/* <div className="col-md-12 mt-2">
                <label className="form-label">Description</label>
                <ReactQuill
                  defaultValue={description}
                  onChange={setDescription}
                />
                <div className="invalid-feedback">
                  {errors.description && errors.description.message}
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <label className="form-label">Return-policy</label>
                <ReactQuill
                  defaultValue={returnpolicy}
                  onChange={setReturnPolicy}
                />
                <div className="invalid-feedback">
                  {errors.return_policy && errors.return_policy.message}
                </div>
              </div> */}

              <div className="d-flex flex-column gap-4">
                {/* Description Editor */}
                <div className="col-md-12 mt-2">
                  <label className="form-label">Description</label>
                  <ReactQuill
                    defaultValue={description}
                    onChange={setDescription}
                    style={{ height: "200px", marginBottom: "20px" }}
                     modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],

                      ["bold", "italic", "underline", "strike"],

                      [{ color: [] }, { background: [] }],

                      [{ align: [] }],

                      [{ list: "ordered" }, { list: "bullet" }],

                      ["blockquote"],

                      ["link", "image"],

                      ["clean"],
                    ],
                  }}
                  />
                  <div className="invalid-feedback">
                    {errors.description && errors.description.message}
                  </div>
                </div>

                {/* Return Policy Editor */}
                <div className="col-md-12 mt-2">
                  <label className="form-label mt-md-0 mt-sm-3">
                    Return-policy
                  </label>
                  <ReactQuill
                    value={returnpolicy}
                    onChange={setReturnPolicy}
                    style={{ height: "150px", marginBottom: "20px" }} // Space added
                     modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],

                      ["bold", "italic", "underline", "strike"],

                      [{ color: [] }, { background: [] }],

                      [{ align: [] }],

                      [{ list: "ordered" }, { list: "bullet" }],

                      ["blockquote"],

                      ["link", "image"],

                      ["clean"],
                    ],
                  }}
                  />
                  <div className="invalid-feedback">
                    {errors.return_policy && errors.return_policy.message}
                  </div>
                </div>

                {/* Parent Category (Ensuring Proper Spacing) */}

                <div className="col-md-12">
                  <label className="form-label">Return_period</label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors?.return_period && "is-invalid"
                    }`}
                    {...register("return_period", { required: true })}
                  />
                  <div className="invalid-feedback">
                    {errors.return_period && errors.return_period.message}
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="form-label">Parent category</label>
                  <AsyncSelect
                    defaultOptions
                    loadOptions={handleOnSearchcategory}
                    placeholder="Search here..."
                    isClearable={true}
                    name={"parent_id"}
                  />
                  <div className="invalid-feedback">
                    {errors.parent_id && errors.parent_id.message}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {console.log(watch('attributes'))} */}
          <Card.Header>
            Attributes{" "}
            <button
              type="button"
              className="btn btn-primary btn-sm me-3 float-end"
              onClick={handleAddFields}
            >
              Add
            </button>
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover className="table-responsive">
              <thead className="text-left">
                <tr>
                  <th>Attributes</th>
                  <th>Required</th>
                  <th>Primary</th>
                  <th>Label</th>
                </tr>
              </thead>
              <tbody className="text-left">
                {attributes?.map((elementInArray, index) => {
                  return (
                    <tr key={`attr-index-${index}`}>
                      <td>
                        <input
                          type="hidden"
                          {...register(`attributes[${index}][name]`)}
                        />
                        <input
                          type="hidden"
                          {...register(`attributes[${index}][id]`)}
                        />
                        <AsyncSelect
                          defaultOptions
                          loadOptions={handleOnSearchAttribute}
                          placeholder="Search attributes..."
                          isClearable={true}
                          value={selectedAttributes[index] || null}
                          onChange={(selectedOption) => 
                            handleAttributeChange(selectedOption, index)
                          }
                          className={`${
                            errors?.attributes && "is-invalid"
                          }`}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '38px',
                              fontSize: '14px'
                            })
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          defaultChecked={elementInArray?.is_required}
                          name={`attributes[${index}][is_required]`}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          defaultChecked={elementInArray?.is_primary}
                          name={`attributes[${index}][is_primary]`}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          {...register(`attributes[${index}][label]`)}
                          readOnly
                          className="form-control-sm"
                          style={{ 
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ddd',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            width: '100%'
                          }}
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm me-3 float-end"
                          onClick={() => handleRemoveFields(index)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
          <Card.Header>SEO</Card.Header>
          <Card.Body>
            <div className="col-md-12">
              <label className="form-label">Meta-title</label>
              <input
                type="text"
                className={`form-control ${errors?.metatitle && "is-invalid"}`}
                {...register("meta[title]")}
              />
              <div className="invalid-feedback">
                {errors.metatitle && errors.metatitle.message}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <label className="form-label">Meta-description</label>
              <textarea
                type="text"
                className={`form-control ${
                  errors?.metadescription && "is-invalid"
                }`}
                {...register("meta[description]")}
              />
              <div className="invalid-feedback">
                {errors.metadescription && errors.metadescription.message}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <label className="form-label">Meta-keywords</label>
              <input
                type="text"
                className={`form-control ${
                  errors?.metakeywords && "is-invalid"
                }`}
                {...register("meta[keywords]")}
              />
              <div className="invalid-feedback">
                {errors.metakeywords && errors.metakeywords.message}
              </div>
            </div>
          </Card.Body>
          <div className="card-footer">
            <button
              type="submit"
              disabled={isSubmitting ? "disabled" : ""}
              className="btn btn-primary float-end"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Page;